import type { PropsWithChildren, ReactNode } from 'react';

import { type FlexProps, Flex } from '@valwin/facto/components';

export type SectionPanelProps = FlexProps & {
  title?: ReactNode;
  actions?: ReactNode;
};

export function SectionPanel({
  title,
  actions,
  children,
  ...rest
}: PropsWithChildren<SectionPanelProps>) {
  const hasHeader = title || actions;

  return (
    <Flex
      flexDirection="column"
      gap="2"
      padding="4"
      borderRadius="md"
      background="bg.panel"
      border="1px solid"
      borderColor="gray.200"
      height="fit-content"
      {...rest}
    >
      {hasHeader && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          gap="2"
          paddingBottom="2"
        >
          {title && (
            <Flex
              alignItems="center"
              gap="2"
              color="fg.muted"
              fontWeight="medium"
              fontSize="sm"
              letterSpacing="1px"
              textTransform="uppercase"
            >
              {title}
            </Flex>
          )}
          {actions && (
            <Flex alignItems="center" gap="2">
              {actions}
            </Flex>
          )}
        </Flex>
      )}
      {children}
    </Flex>
  );
}
